import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import Header from "./Header";
import Footer from "./Footer";
import TabletHeader from "./TabletHeader";
import MobileHeader from "./MobileHeader";
import MobileMenu from "./MobileMenu";
import MobileFooter from "./MobileFooter";

export default function RootLayout() {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileProdotti, setShowMobileProdotti] = useState(false);

  const ToggleMobileMenu = (event) => {
    event.preventDefault();
    setShowMobileMenu((prev) => !prev);
  };
  const ToggleMobileProdotti = () => {
    setShowMobileProdotti((prev) => !prev);
    const menu = document.querySelector(".menus");
    if (showMobileProdotti) {
      menu.style.marginLeft = "20px";
    } else {
      menu.style.marginLeft = "0px";
    }
  };
  const isBigScreen = useMediaQuery({
    query: "(min-width: 1100px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1099px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width:  1099px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const location = useLocation();
  useEffect(() => {
    setShowMobileMenu(false);
    setShowMobileProdotti(false);
    const menu = document.querySelector(".menus");
    if (menu) menu.style.marginLeft = "20px";
  }, [location]);

  return (
    <>
      {isBigScreen && <Header />}
      {isTablet && (
        <TabletHeader
          showMobileMenu={ToggleMobileMenu}
          isopen={showMobileMenu}
        />
      )}
      {isMobile && (
        <MobileHeader
          showMobileMenu={ToggleMobileMenu}
          isopen={showMobileMenu}
        />
      )}

      <Outlet />
      {isTabletOrMobile && <MobileFooter />}
      {isBigScreen && <Footer />}
    </>
  );
}
